


export default{

    app:{
        home_title:"澳門特區政府出版物銷售",
        home_address:"詳細地址",
        home_lr:"最新推薦",
        home_publisher:"出版機構",
        home_publishlang:"語言",
        home_publishdate:"出版日期",
        home_search:"名稱/作者/出版機構",
        home_cancel:"取消",
        home_detail_title:"出版物詳情",
        home_ml:"目錄",
        home_category:"所屬分類",
        home_author:"編著",
        home_soldmaiche:"售賣機",
        home_search_item:"搜索",
        home_sure:"確認",
        // home_selectSoldMachie:"請選擇售賣機",
        home_soldOut:"已售罄",
        home_free:"免費",
        home_selectSoldMachie:"全部售賣機",
    }
    
}